import common from "./common";
import notification from "./notification";
import account from "./account";
import security from "./security";
import setting from "./setting";
import document from "./document";
import feedback from "./feedback";
import mall from "./mall";
import assets from "./assets";

export default {
    common,
    notification,
    account,
    security,
    setting,
    document,
    feedback,
    mall,
    assets,
};
